import React from 'react';
import { ModalContentWrapper, ModalWrapper } from './Modal.style';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Modal: React.FC<any> = ({ children }) => {
    return (
        <ModalWrapper role="modal">
            <ModalContentWrapper role="modalContent">{children}</ModalContentWrapper>
        </ModalWrapper>
    );
};

export default React.memo(Modal);
